(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reveal-observer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__rvRevealObserverInitialized) {
      return;
    }
    window.__rvRevealObserverInitialized = true;

    const sections = document.querySelectorAll('[data-rv-reveal]');
    if (!sections.length) {
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      sections.forEach((section) => {
        section.classList.add('is-visible');
      });
      return;
    }

    const parseThreshold = (value, fallback) => {
      const parsed = Number.parseFloat(value);
      if (!Number.isFinite(parsed)) {
        return fallback;
      }
      return Math.min(1, Math.max(0, parsed));
    };

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    sections.forEach((section) => {
      const thresholdValue = isMobile && section.dataset.rvRevealMobileThreshold ? section.dataset.rvRevealMobileThreshold : section.dataset.rvRevealThreshold;
      const rootMarginValue = isMobile && section.dataset.rvRevealMobileRootMargin ? section.dataset.rvRevealMobileRootMargin : section.dataset.rvRevealRootMargin;
      const threshold = parseThreshold(thresholdValue, 0.14);
      const rootMargin = rootMarginValue || '0px 0px -8% 0px';

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold,
          rootMargin
        }
      );

      observer.observe(section);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sanitize-text-nodes"] && !Shopify.designMode) return;
  try {
    (() => {
    const hiddenCharacterPattern = /[\u200B\u2028\u2029\u2060\uFEFF]/g;
    const skipTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT']);

    const sanitizeTextNode = (node) => {
      if (!node || !node.nodeValue) {
        return;
      }

      const parent = node.parentElement;
      if (parent && skipTags.has(parent.tagName)) {
        return;
      }

      if (!hiddenCharacterPattern.test(node.nodeValue)) {
        hiddenCharacterPattern.lastIndex = 0;
        return;
      }

      node.nodeValue = node.nodeValue.replace(hiddenCharacterPattern, '');
      hiddenCharacterPattern.lastIndex = 0;
    };

    const sanitizeTree = (root) => {
      if (!root) {
        return;
      }

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let currentNode = walker.nextNode();

      while (currentNode) {
        sanitizeTextNode(currentNode);
        currentNode = walker.nextNode();
      }
    };

    sanitizeTree(document.body);
  })();
  } catch(e) { console.error(e); }
})();

})();
